/* tslint:disable */
/* eslint-disable */
/**
 * grpc/calendar/calendar.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { CalendarCreateCalendarEntryRequest } from '../models'
// @ts-ignore
import { CalendarCreateCalendarEntryResponse } from '../models'
// @ts-ignore
import { CalendarGetCalendarEntryResponse } from '../models'
// @ts-ignore
import { CalendarGetManagerFreeSlotsResponse } from '../models'
// @ts-ignore
import { CalendarListCalendarEntriesResponse } from '../models'
// @ts-ignore
import { CalendarServiceUpdateCalendarEntryBody } from '../models'
// @ts-ignore
import { CalendarUpdateCalendarEntryResponse } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
/**
 * CalendarServiceApi - axios parameter creator
 * @export
 */
export const CalendarServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Adds an entry to the calling user\'s calendar.
     * @param {CalendarCreateCalendarEntryRequest} body A new calendar entry.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceCreateCalendarEntry: async (
      body: CalendarCreateCalendarEntryRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('calendarServiceCreateCalendarEntry', 'body', body)
      const localVarPath = `/api/v1/calendar/entries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes an entry.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceDeleteCalendarEntry: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('calendarServiceDeleteCalendarEntry', 'id', id)
      const localVarPath = `/api/v1/calendar/entries/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one entry with the names behind its identifiers resolved.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceGetCalendarEntry: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('calendarServiceGetCalendarEntry', 'id', id)
      const localVarPath = `/api/v1/calendar/entries/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the hour-long slots a manager is free in, so that someone outside the company can book into one. Only the start and end of each slot are returned — never what fills the rest of the calendar.
     * @param {string} [managerId]
     * @param {string} [from]
     * @param {string} [to] End of the window. Absent means a default window from the start.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceGetManagerFreeSlots: async (
      managerId?: string,
      from?: string,
      to?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/calendar/free-slots`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (managerId !== undefined) {
        localVarQueryParameter['managerId'] = managerId
      }

      if (from !== undefined) {
        localVarQueryParameter['from'] =
          (from as any) instanceof Date ? (from as any).toISOString() : from
      }

      if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any) instanceof Date ? (to as any).toISOString() : to
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists entries with filters and paging.
     * @param {string} [managerId] Whose calendar to read. Kept for older clients; prefer the list below.
     * @param {CalendarServiceListCalendarEntriesEntityTypeEnum} [entityType] Return only entries about this kind of record.   - ENTITY_TYPE_CLIENT: A client.  - ENTITY_TYPE_DEAL: A deal.  - ENTITY_TYPE_DEAL_TASK: A tracker task on a deal. Since DEV-1443 every task lives in the tracker, and the type names what the task is about rather than where it is stored: it is what a link back to the deal card is built from.  - ENTITY_TYPE_CLIENT_TASK: A tracker task about a client.  - ENTITY_TYPE_AGENT_TASK: A tracker task about a partner agent.  - ENTITY_TYPE_TRACKER_ISSUE: A tracker task belonging to no record outside the tracker (DEV-1385).  - ENTITY_TYPE_TRACKER_MEETING: A meeting scheduled in the tracker; one entry per participant, kept by the tracker meeting sync (DEV-2215).
     * @param {string} [entityId] Return only entries about this record.
     * @param {string} [startDate] Only entries starting at or after this moment.
     * @param {string} [endDate] Only entries starting before this moment.
     * @param {string} [search] Text to match against titles and descriptions.
     * @param {Array<string>} [managerIds] Calendars to read at once, which is what a team view is built from. Reading someone else\&#39;s calendar requires the right to do so.
     * @param {Array<string>} [taskTypeIds] Return only tasks of these types, from the task type catalogue of the tasks service. Entries a person created by hand carry no task type, so this filters them out.
     * @param {CalendarServiceListCalendarEntriesCategoryEnum} [category] Return only appointments of this kind: a call, a viewing, a meeting.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceListCalendarEntries: async (
      managerId?: string,
      entityType?: CalendarServiceListCalendarEntriesEntityTypeEnum,
      entityId?: string,
      startDate?: string,
      endDate?: string,
      search?: string,
      managerIds?: Array<string>,
      taskTypeIds?: Array<string>,
      category?: CalendarServiceListCalendarEntriesCategoryEnum,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/calendar/entries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (managerId !== undefined) {
        localVarQueryParameter['managerId'] = managerId
      }

      if (entityType !== undefined) {
        localVarQueryParameter['entityType'] = entityType
      }

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString() : startDate
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString() : endDate
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search
      }

      if (managerIds) {
        localVarQueryParameter['managerIds'] = managerIds
      }

      if (taskTypeIds) {
        localVarQueryParameter['taskTypeIds'] = taskTypeIds
      }

      if (category !== undefined) {
        localVarQueryParameter['category'] = category
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the entries about one particular client, deal or task.
     * @param {CalendarServiceListCalendarEntriesByEntityEntityTypeEnum} entityType
     * @param {string} entityId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceListCalendarEntriesByEntity: async (
      entityType: CalendarServiceListCalendarEntriesByEntityEntityTypeEnum,
      entityId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entityType' is not null or undefined
      assertParamExists('calendarServiceListCalendarEntriesByEntity', 'entityType', entityType)
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('calendarServiceListCalendarEntriesByEntity', 'entityId', entityId)
      const localVarPath = `/api/v1/calendar/entities/{entityType}/{entityId}/entries`
        .replace(`{${'entityType'}}`, encodeURIComponent(String(entityType)))
        .replace(`{${'entityId'}}`, encodeURIComponent(String(entityId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes an entry. Fields left out keep their current values.
     * @param {string} id
     * @param {CalendarServiceUpdateCalendarEntryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceUpdateCalendarEntry: async (
      id: string,
      body: CalendarServiceUpdateCalendarEntryBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('calendarServiceUpdateCalendarEntry', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('calendarServiceUpdateCalendarEntry', 'body', body)
      const localVarPath = `/api/v1/calendar/entries/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CalendarServiceApi - functional programming interface
 * @export
 */
export const CalendarServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CalendarServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Adds an entry to the calling user\'s calendar.
     * @param {CalendarCreateCalendarEntryRequest} body A new calendar entry.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceCreateCalendarEntry(
      body: CalendarCreateCalendarEntryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CalendarCreateCalendarEntryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceCreateCalendarEntry(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceCreateCalendarEntry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes an entry.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceDeleteCalendarEntry(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceDeleteCalendarEntry(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceDeleteCalendarEntry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one entry with the names behind its identifiers resolved.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceGetCalendarEntry(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarGetCalendarEntryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceGetCalendarEntry(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceGetCalendarEntry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the hour-long slots a manager is free in, so that someone outside the company can book into one. Only the start and end of each slot are returned — never what fills the rest of the calendar.
     * @param {string} [managerId]
     * @param {string} [from]
     * @param {string} [to] End of the window. Absent means a default window from the start.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceGetManagerFreeSlots(
      managerId?: string,
      from?: string,
      to?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CalendarGetManagerFreeSlotsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceGetManagerFreeSlots(
        managerId,
        from,
        to,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceGetManagerFreeSlots']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists entries with filters and paging.
     * @param {string} [managerId] Whose calendar to read. Kept for older clients; prefer the list below.
     * @param {CalendarServiceListCalendarEntriesEntityTypeEnum} [entityType] Return only entries about this kind of record.   - ENTITY_TYPE_CLIENT: A client.  - ENTITY_TYPE_DEAL: A deal.  - ENTITY_TYPE_DEAL_TASK: A tracker task on a deal. Since DEV-1443 every task lives in the tracker, and the type names what the task is about rather than where it is stored: it is what a link back to the deal card is built from.  - ENTITY_TYPE_CLIENT_TASK: A tracker task about a client.  - ENTITY_TYPE_AGENT_TASK: A tracker task about a partner agent.  - ENTITY_TYPE_TRACKER_ISSUE: A tracker task belonging to no record outside the tracker (DEV-1385).  - ENTITY_TYPE_TRACKER_MEETING: A meeting scheduled in the tracker; one entry per participant, kept by the tracker meeting sync (DEV-2215).
     * @param {string} [entityId] Return only entries about this record.
     * @param {string} [startDate] Only entries starting at or after this moment.
     * @param {string} [endDate] Only entries starting before this moment.
     * @param {string} [search] Text to match against titles and descriptions.
     * @param {Array<string>} [managerIds] Calendars to read at once, which is what a team view is built from. Reading someone else\&#39;s calendar requires the right to do so.
     * @param {Array<string>} [taskTypeIds] Return only tasks of these types, from the task type catalogue of the tasks service. Entries a person created by hand carry no task type, so this filters them out.
     * @param {CalendarServiceListCalendarEntriesCategoryEnum} [category] Return only appointments of this kind: a call, a viewing, a meeting.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceListCalendarEntries(
      managerId?: string,
      entityType?: CalendarServiceListCalendarEntriesEntityTypeEnum,
      entityId?: string,
      startDate?: string,
      endDate?: string,
      search?: string,
      managerIds?: Array<string>,
      taskTypeIds?: Array<string>,
      category?: CalendarServiceListCalendarEntriesCategoryEnum,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CalendarListCalendarEntriesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceListCalendarEntries(
        managerId,
        entityType,
        entityId,
        startDate,
        endDate,
        search,
        managerIds,
        taskTypeIds,
        category,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceListCalendarEntries']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the entries about one particular client, deal or task.
     * @param {CalendarServiceListCalendarEntriesByEntityEntityTypeEnum} entityType
     * @param {string} entityId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceListCalendarEntriesByEntity(
      entityType: CalendarServiceListCalendarEntriesByEntityEntityTypeEnum,
      entityId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CalendarListCalendarEntriesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.calendarServiceListCalendarEntriesByEntity(
          entityType,
          entityId,
          paginationPage,
          paginationPerPage,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceListCalendarEntriesByEntity']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes an entry. Fields left out keep their current values.
     * @param {string} id
     * @param {CalendarServiceUpdateCalendarEntryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async calendarServiceUpdateCalendarEntry(
      id: string,
      body: CalendarServiceUpdateCalendarEntryBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CalendarUpdateCalendarEntryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.calendarServiceUpdateCalendarEntry(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['CalendarServiceApi.calendarServiceUpdateCalendarEntry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * CalendarServiceApi - factory interface
 * @export
 */
export const CalendarServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CalendarServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Adds an entry to the calling user\'s calendar.
     * @param {CalendarCreateCalendarEntryRequest} body A new calendar entry.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceCreateCalendarEntry(
      body: CalendarCreateCalendarEntryRequest,
      options?: any,
    ): AxiosPromise<CalendarCreateCalendarEntryResponse> {
      return localVarFp
        .calendarServiceCreateCalendarEntry(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes an entry.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceDeleteCalendarEntry(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .calendarServiceDeleteCalendarEntry(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one entry with the names behind its identifiers resolved.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceGetCalendarEntry(
      id: string,
      options?: any,
    ): AxiosPromise<CalendarGetCalendarEntryResponse> {
      return localVarFp
        .calendarServiceGetCalendarEntry(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the hour-long slots a manager is free in, so that someone outside the company can book into one. Only the start and end of each slot are returned — never what fills the rest of the calendar.
     * @param {string} [managerId]
     * @param {string} [from]
     * @param {string} [to] End of the window. Absent means a default window from the start.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceGetManagerFreeSlots(
      managerId?: string,
      from?: string,
      to?: string,
      options?: any,
    ): AxiosPromise<CalendarGetManagerFreeSlotsResponse> {
      return localVarFp
        .calendarServiceGetManagerFreeSlots(managerId, from, to, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists entries with filters and paging.
     * @param {string} [managerId] Whose calendar to read. Kept for older clients; prefer the list below.
     * @param {CalendarServiceListCalendarEntriesEntityTypeEnum} [entityType] Return only entries about this kind of record.   - ENTITY_TYPE_CLIENT: A client.  - ENTITY_TYPE_DEAL: A deal.  - ENTITY_TYPE_DEAL_TASK: A tracker task on a deal. Since DEV-1443 every task lives in the tracker, and the type names what the task is about rather than where it is stored: it is what a link back to the deal card is built from.  - ENTITY_TYPE_CLIENT_TASK: A tracker task about a client.  - ENTITY_TYPE_AGENT_TASK: A tracker task about a partner agent.  - ENTITY_TYPE_TRACKER_ISSUE: A tracker task belonging to no record outside the tracker (DEV-1385).  - ENTITY_TYPE_TRACKER_MEETING: A meeting scheduled in the tracker; one entry per participant, kept by the tracker meeting sync (DEV-2215).
     * @param {string} [entityId] Return only entries about this record.
     * @param {string} [startDate] Only entries starting at or after this moment.
     * @param {string} [endDate] Only entries starting before this moment.
     * @param {string} [search] Text to match against titles and descriptions.
     * @param {Array<string>} [managerIds] Calendars to read at once, which is what a team view is built from. Reading someone else\&#39;s calendar requires the right to do so.
     * @param {Array<string>} [taskTypeIds] Return only tasks of these types, from the task type catalogue of the tasks service. Entries a person created by hand carry no task type, so this filters them out.
     * @param {CalendarServiceListCalendarEntriesCategoryEnum} [category] Return only appointments of this kind: a call, a viewing, a meeting.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceListCalendarEntries(
      managerId?: string,
      entityType?: CalendarServiceListCalendarEntriesEntityTypeEnum,
      entityId?: string,
      startDate?: string,
      endDate?: string,
      search?: string,
      managerIds?: Array<string>,
      taskTypeIds?: Array<string>,
      category?: CalendarServiceListCalendarEntriesCategoryEnum,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<CalendarListCalendarEntriesResponse> {
      return localVarFp
        .calendarServiceListCalendarEntries(
          managerId,
          entityType,
          entityId,
          startDate,
          endDate,
          search,
          managerIds,
          taskTypeIds,
          category,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the entries about one particular client, deal or task.
     * @param {CalendarServiceListCalendarEntriesByEntityEntityTypeEnum} entityType
     * @param {string} entityId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceListCalendarEntriesByEntity(
      entityType: CalendarServiceListCalendarEntriesByEntityEntityTypeEnum,
      entityId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<CalendarListCalendarEntriesResponse> {
      return localVarFp
        .calendarServiceListCalendarEntriesByEntity(
          entityType,
          entityId,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes an entry. Fields left out keep their current values.
     * @param {string} id
     * @param {CalendarServiceUpdateCalendarEntryBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarServiceUpdateCalendarEntry(
      id: string,
      body: CalendarServiceUpdateCalendarEntryBody,
      options?: any,
    ): AxiosPromise<CalendarUpdateCalendarEntryResponse> {
      return localVarFp
        .calendarServiceUpdateCalendarEntry(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * CalendarServiceApi - object-oriented interface
 * @export
 * @class CalendarServiceApi
 * @extends {BaseAPI}
 */
export class CalendarServiceApi extends BaseAPI {
  /**
   *
   * @summary Adds an entry to the calling user\'s calendar.
   * @param {CalendarCreateCalendarEntryRequest} body A new calendar entry.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceCreateCalendarEntry(
    body: CalendarCreateCalendarEntryRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceCreateCalendarEntry(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes an entry.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceDeleteCalendarEntry(id: string, options?: RawAxiosRequestConfig) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceDeleteCalendarEntry(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one entry with the names behind its identifiers resolved.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceGetCalendarEntry(id: string, options?: RawAxiosRequestConfig) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceGetCalendarEntry(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the hour-long slots a manager is free in, so that someone outside the company can book into one. Only the start and end of each slot are returned — never what fills the rest of the calendar.
   * @param {string} [managerId]
   * @param {string} [from]
   * @param {string} [to] End of the window. Absent means a default window from the start.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceGetManagerFreeSlots(
    managerId?: string,
    from?: string,
    to?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceGetManagerFreeSlots(managerId, from, to, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists entries with filters and paging.
   * @param {string} [managerId] Whose calendar to read. Kept for older clients; prefer the list below.
   * @param {CalendarServiceListCalendarEntriesEntityTypeEnum} [entityType] Return only entries about this kind of record.   - ENTITY_TYPE_CLIENT: A client.  - ENTITY_TYPE_DEAL: A deal.  - ENTITY_TYPE_DEAL_TASK: A tracker task on a deal. Since DEV-1443 every task lives in the tracker, and the type names what the task is about rather than where it is stored: it is what a link back to the deal card is built from.  - ENTITY_TYPE_CLIENT_TASK: A tracker task about a client.  - ENTITY_TYPE_AGENT_TASK: A tracker task about a partner agent.  - ENTITY_TYPE_TRACKER_ISSUE: A tracker task belonging to no record outside the tracker (DEV-1385).  - ENTITY_TYPE_TRACKER_MEETING: A meeting scheduled in the tracker; one entry per participant, kept by the tracker meeting sync (DEV-2215).
   * @param {string} [entityId] Return only entries about this record.
   * @param {string} [startDate] Only entries starting at or after this moment.
   * @param {string} [endDate] Only entries starting before this moment.
   * @param {string} [search] Text to match against titles and descriptions.
   * @param {Array<string>} [managerIds] Calendars to read at once, which is what a team view is built from. Reading someone else\&#39;s calendar requires the right to do so.
   * @param {Array<string>} [taskTypeIds] Return only tasks of these types, from the task type catalogue of the tasks service. Entries a person created by hand carry no task type, so this filters them out.
   * @param {CalendarServiceListCalendarEntriesCategoryEnum} [category] Return only appointments of this kind: a call, a viewing, a meeting.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceListCalendarEntries(
    managerId?: string,
    entityType?: CalendarServiceListCalendarEntriesEntityTypeEnum,
    entityId?: string,
    startDate?: string,
    endDate?: string,
    search?: string,
    managerIds?: Array<string>,
    taskTypeIds?: Array<string>,
    category?: CalendarServiceListCalendarEntriesCategoryEnum,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceListCalendarEntries(
        managerId,
        entityType,
        entityId,
        startDate,
        endDate,
        search,
        managerIds,
        taskTypeIds,
        category,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the entries about one particular client, deal or task.
   * @param {CalendarServiceListCalendarEntriesByEntityEntityTypeEnum} entityType
   * @param {string} entityId
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceListCalendarEntriesByEntity(
    entityType: CalendarServiceListCalendarEntriesByEntityEntityTypeEnum,
    entityId: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceListCalendarEntriesByEntity(
        entityType,
        entityId,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes an entry. Fields left out keep their current values.
   * @param {string} id
   * @param {CalendarServiceUpdateCalendarEntryBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CalendarServiceApi
   */
  public calendarServiceUpdateCalendarEntry(
    id: string,
    body: CalendarServiceUpdateCalendarEntryBody,
    options?: RawAxiosRequestConfig,
  ) {
    return CalendarServiceApiFp(this.configuration)
      .calendarServiceUpdateCalendarEntry(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const CalendarServiceListCalendarEntriesEntityTypeEnum = {
  Invalid: 'ENTITY_TYPE_INVALID',
  Client: 'ENTITY_TYPE_CLIENT',
  Deal: 'ENTITY_TYPE_DEAL',
  DealTask: 'ENTITY_TYPE_DEAL_TASK',
  ClientTask: 'ENTITY_TYPE_CLIENT_TASK',
  AgentTask: 'ENTITY_TYPE_AGENT_TASK',
  TrackerIssue: 'ENTITY_TYPE_TRACKER_ISSUE',
  TrackerMeeting: 'ENTITY_TYPE_TRACKER_MEETING',
} as const
export type CalendarServiceListCalendarEntriesEntityTypeEnum =
  (typeof CalendarServiceListCalendarEntriesEntityTypeEnum)[keyof typeof CalendarServiceListCalendarEntriesEntityTypeEnum]
/**
 * @export
 */
export const CalendarServiceListCalendarEntriesCategoryEnum = {
  Unspecified: 'EVENT_CATEGORY_UNSPECIFIED',
  Call: 'EVENT_CATEGORY_CALL',
  Showing: 'EVENT_CATEGORY_SHOWING',
  Meeting: 'EVENT_CATEGORY_MEETING',
  Task: 'EVENT_CATEGORY_TASK',
  Other: 'EVENT_CATEGORY_OTHER',
} as const
export type CalendarServiceListCalendarEntriesCategoryEnum =
  (typeof CalendarServiceListCalendarEntriesCategoryEnum)[keyof typeof CalendarServiceListCalendarEntriesCategoryEnum]
/**
 * @export
 */
export const CalendarServiceListCalendarEntriesByEntityEntityTypeEnum = {
  Invalid: 'ENTITY_TYPE_INVALID',
  Client: 'ENTITY_TYPE_CLIENT',
  Deal: 'ENTITY_TYPE_DEAL',
  DealTask: 'ENTITY_TYPE_DEAL_TASK',
  ClientTask: 'ENTITY_TYPE_CLIENT_TASK',
  AgentTask: 'ENTITY_TYPE_AGENT_TASK',
  TrackerIssue: 'ENTITY_TYPE_TRACKER_ISSUE',
  TrackerMeeting: 'ENTITY_TYPE_TRACKER_MEETING',
} as const
export type CalendarServiceListCalendarEntriesByEntityEntityTypeEnum =
  (typeof CalendarServiceListCalendarEntriesByEntityEntityTypeEnum)[keyof typeof CalendarServiceListCalendarEntriesByEntityEntityTypeEnum]
